(function () {
    'use strict';

    function initCadViewer(container) {
        var url     = container.getAttribute('data-url');
        var ext     = container.getAttribute('data-ext');
        var loading = container.querySelector('.cad-loading');

        if (!window.wiCadViewer) {
            if (loading) loading.querySelector('span').textContent = 'Viewer not loaded';
            return;
        }

        window.wiCadViewer.init(container, url, ext)
            .then(function () {
                if (loading) loading.remove();
            })
            .catch(function () {
                if (loading) loading.querySelector('span').textContent = 'Cannot render file';
            });
    }

    $(document).on('shown.bs.modal', '#view_media', function () {
        var container = document.querySelector('#view_media .cad-viewer-wrap #cad-viewer-container');
        if (container) initCadViewer(container);
    });
}());
